import type { GalleryItem } from '../types/content'

// Afbeeldingen aangeleverd door de eigenaar, voor beide carrousels.
export const tricotinGallery: GalleryItem[] = [
  {
    id: 'g1',
    motif: 'sleutelhanger hart',
    src: 'https://cdn.magicpatterns.com/uploads/33xufjKsmo8e4oBws4w6UC/image.png',
    alt: 'Hand met een hartvormige sleutelhanger van punnikkoord in roze, lila en mint, met letterkralen die de naam Isabelle vormen, voor een rij dezelfde sleutelhangers',
  },
  {
    id: 'g2',
    motif: 'bloemen bedankjes',
    src: 'https://cdn.magicpatterns.com/uploads/d5LAtcVCSQ73EnE2NiNZu7/image.png',
    alt: 'Bedankjes met madeliefjes, een zon en een regenboog van pastelkleurig punnikkoord op houten voetjes, met labels en linten',
  },
  {
    id: 'g3',
    motif: 'naam ring',
    src: 'https://cdn.magicpatterns.com/uploads/vJ1Do53efDjLxKgnYupA3R/image.png',
    alt: 'De naam Gabriel van lichtblauw punnikkoord op een hangende houten ring, met ballonnen en een konijntje op een schommel',
  },
  {
    id: 'g4',
    motif: 'regenboog naam',
    src: 'https://cdn.magicpatterns.com/uploads/jmnGN8YBjVBGtTS9VnHsRn/image.png',
    alt: 'Regenboog van paars, roze en wit punnikkoord met pompons en de naam Emma in lila punnikkoord',
  },
  {
    id: 'g5',
    motif: 'naam autootje',
    src: 'https://cdn.magicpatterns.com/uploads/9ZxxQzDMeeVej9vBnCZNCg/image.png',
    alt: 'De naam Oliver en een autootje van blauw punnikkoord in een ronde, crèmekleurige gevlochten lijst',
  },
  {
    id: 'g7',
    motif: 'letter in lijst',
    src: 'https://cdn.magicpatterns.com/uploads/2ZWQKGAoYiHKAPJ1FGu8tU/image.png',
    alt: 'Twee witte lijstjes met een letter M en een regenboog van roze punnikkoord op een kanten achtergrond',
  },
  {
    id: 'g8',
    motif: 'cijfers taarttopper',
    src: 'https://cdn.magicpatterns.com/uploads/xsZeopAu2rqfpPsU4ERmF2/image.png',
    alt: 'De cijfers 1, 8 en 3 van roze punnikkoord met beige strikjes, verpakt op kraftkaartjes',
  },
  {
    id: 'g9',
    motif: 'hartjes taarttopper',
    src: 'https://cdn.magicpatterns.com/uploads/1WgBpZGBZfFUQATSv53iHa/image.png',
    alt: 'Hand met een taarttopper met twee hartjes van saliegroen en lichtblauw punnikkoord en een blauwe strik',
  },
  {
    id: 'g10',
    motif: 'beertje',
    src: 'https://cdn.magicpatterns.com/uploads/8bTtt4LLosjk2AHi3T6LBH/image.png',
    alt: 'Hand met een beertje van crèmekleurig punnikkoord met een roze tutu van tule en een pomponneusje',
  },
  {
    id: 'g11',
    motif: 'kerst',
    src: 'https://cdn.magicpatterns.com/uploads/3yofmPmLdgrwrNRREA1W7s/image.png',
    alt: 'Kerstdecoraties van punnikkoord: een zuurstok, een peperkoekhuisje, een peperkoekmannetje, boompjes, een envelop, een cadeautje en het woord ho',
  },
  {
    id: 'g12',
    motif: 'paashaasje',
    src: 'https://cdn.magicpatterns.com/uploads/cUnQDcMpjaxXMwoTigD7TF/image.png',
    alt: 'Eivormige krans van saliegroen punnikkoord met een okergeel konijntje en roze bloemen',
  },
]
